// extracted by css-extract-rspack-plugin
export default {"cls1":"Typeahead-cls1_C9x","cls2":"Typeahead-cls2_gLz Typeahead-cls1_C9x","selected":"Typeahead-selected_1yr"};